import React, { useState, useEffect } from "react";
import axios from "axios";
import DefaultLogo from "../assets/image/logo.png";

const DynamicLogo = ({ style, className, alt = "logo-img", onClick }) => {
  const [brandingLogo, setBrandingLogo] = useState("");

  useEffect(() => {
    // Check if we already have it in localStorage to avoid flicker (optional cache)
    const cachedLogo = localStorage.getItem("kce_branding_logo");
    if (cachedLogo) {
      setBrandingLogo(cachedLogo);
    }

    axios
      .get(`${process.env.REACT_APP_API_END_POINT}/get-registration-visibility`)
      .then((res) => {
        if (res.data && res.data.data && res.data.data.branding_logo) {
          setBrandingLogo(res.data.data.branding_logo);
          localStorage.setItem("kce_branding_logo", res.data.data.branding_logo);
        }
      })
      .catch((err) => console.log("Failed to fetch branding logo", err));
  }, []);

  const logoSrc = brandingLogo
    ? `${process.env.REACT_APP_IMAGE_URL}/branding/${brandingLogo}`
    : DefaultLogo;

  return (
    <img
      src={logoSrc}
      alt={alt}
      style={style}
      className={className}
      onClick={onClick}
    />
  );
};

export default DynamicLogo;
